import { variant } from 'styled-system';

const sizeVariant = variant({
  prop: 'size',
  variants: {
    small: {
      px: 'button.small.px',
      py: 'button.small.py',
      fontSize: 'bodies.small',
      fontWeight: 'medium',
      lineHeight: 'button.0',
    },
    medium: {
      px: 'button.medium.px',
      py: 'button.medium.py',
      fontSize: 'bodies.base',
      fontWeight: 'medium',
      lineHeight: 'button.1',
    },
    /**
     * @deprecated
     * use medium instead
     * */
    large: {
      px: 'button.medium.px',
      py: 'button.medium.py',
      fontSize: 'bodies.base',
      fontWeight: 'medium',
      lineHeight: 'button.1',
    },
  },
});

export default sizeVariant;
